import * as types from '../actionTypes/candidateBoard'

export function getCandidateBoardsForCandidate(candidateBoards) {
  return {
    type: types.GET_CANDIDATEBOARD_FOR_CANDIDATE,
    candidateBoards
  }
}

export function getCandidateBoard(candidateBoard) {
  return {
    type: types.GET_CANDIDATEBOARD,
    candidateBoard 
  } 
}

export function updateCandidateBoard(candidateBoard) {
  return {
    type: types.UPDATE_CANDIDATEBOARD_FOR_CANDIDATE,
    candidateBoard
  }
}

export function addCandidateBoardToCandidate(candidateBoard) {
  return {
    type: types.ADD_CANDIDATEBOARD_TO_CANDIDATE,
    candidateBoard
  }
}

export function removeBoardFormCandidate(candidateBoardId) {
  return {
    type: types.REMOVE_CANDIDATEBOARD_FROM_CANDIDATE,
    candidateBoardId
  }
}

export function clearCandidateBoard() {
  return {
    type: types.CLEAR_CANDIDATEBOARD
  }
}

export function clearCandidateBoardFromCandidate() {
  return {
    type: types.CLEAR_CANDIDATEBOARD_FOR_CANDIDATE
  }
}


// WEBPACK FOOTER //
// ./src/actions/candidateBoard.js